import { render, staticRenderFns } from "./EntrustDetail.vue?vue&type=template&id=26d8ede1&scoped=true"
import script from "./EntrustDetail.vue?vue&type=script&lang=js"
export * from "./EntrustDetail.vue?vue&type=script&lang=js"
import style0 from "./EntrustDetail.vue?vue&type=style&index=0&id=26d8ede1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d8ede1",
  null
  
)

export default component.exports